<ng-container *ngIf="hasValueToDisplay">

  <span *ngIf="prettyValue; else noChange" [class.positive]="isPositive" [class.negative]="!isPositive">
    ({{ prettyValue }})
  </span>
  <ng-template #noChange>(=)</ng-template>

</ng-container>
